export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PurchaseOrderInvoiceLoader.vue?vue&type=template&id=8cb63ba8&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/PurchaseOrderInvoiceLoader.vue?vue&type=template&id=8cb63ba8&scoped=true
// module id = 2357
// module chunks = 31